import { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { onlineLecture, getTeachers } from "../../../api/onlineLecture";

// Lectures + teachers fetching with the legacy 401 handling (toast + redirect
// to /login). Teachers are sorted by Id descending — a product requirement for
// the teacher picker; sorting here means every consumer sees the same order.
export const useLectureData = (adminToken) => {
    const [lectureList, setLectureList] = useState([]);
    const [teacherList, setTeacherList] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const isAuthError = (res) => res == "Error: Request failed with status code 401";

    const refreshLectures = useCallback(async () => {
        setLoading(true);
        const res = await onlineLecture(adminToken);
        if (res.status == 200) {
            setLectureList(res.data.ResponseData);
        } else if (isAuthError(res)) {
            toast.error("Lütfen Tekrar Giriş Yapınız");
            history.push("/login");
        } else {
            toast.error("Bir hata oluştu lütfen yetkililere ulaşınız");
        }
        setLoading(false);
    }, [adminToken, history]);

    const refreshTeachers = useCallback(async () => {
        setLoading(true);
        const res = await getTeachers(adminToken);
        if (res.status == 200) {
            const sorted = [...res.data.ResponseData].sort((a, b) => b.Id - a.Id);
            setTeacherList(sorted);
        } else if (isAuthError(res)) {
            toast.error("Lütfen Tekrar Giriş Yapınız");
            history.push("/login");
        } else {
            toast.error("Bir hata oluştu lütfen yetkililere ulaşınız");
        }
        setLoading(false);
    }, [adminToken, history]);

    return {
        lectureList,
        teacherList,
        loading,
        setLoading,
        refreshLectures,
        refreshTeachers,
    };
};
